import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { COACH_CONFIG } from '../../coachconfig';

const GiftSuccess = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { apiBaseUrl } = COACH_CONFIG;

  useEffect(() => {
    const handleGiftSuccess = async () => {
      try {
        // Get session ID from URL params
        const urlParams = new URLSearchParams(location.search);
        const sessionId = urlParams.get('session_id');
        
        if (!sessionId) {
          setError('No session ID found');
          setIsLoading(false);
          return;
        }

        // Get gift data from localStorage
        const giftData = localStorage.getItem('pendingGift');
        if (!giftData) {
          setError('No gift data found');
          setIsLoading(false);
          return;
        }

        const parsedGiftData = JSON.parse(giftData);

        // POST gift data to trigger notifications
        const response = await fetch(`${apiBaseUrl}/gifts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...parsedGiftData,
            sessionId,
            status: 'completed'
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to process gift');
        }

        // Clear localStorage
        localStorage.removeItem('pendingGift');
        
        setIsLoading(false);
      } catch (err) {
        console.error('Error processing gift success:', err);
        setError(err.message);
        setIsLoading(false);
      }
    };

    handleGiftSuccess();
  }, [location]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Processing your gift purchase...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-100 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-6">
          <div className="text-sky-500 text-6xl mb-4">⚠️</div>
          <h1 className="text-2xl font-bold text-gray-800 mb-4">Something went wrong</h1>
          <p className="text-gray-600 mb-6">{error}</p>
          <a
            href="/"
            className="inline-block bg-gradient-to-r from-sky-600 to-blue-600 text-white px-6 py-3 rounded-lg hover:from-sky-700 hover:to-blue-700 transition-colors"
          >
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-100 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto p-6">
        <div className="text-sky-500 text-6xl mb-4">🎁</div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Gift Purchase Successful!</h1>
        <p className="text-gray-600 mb-6">
          Thank you for your gift purchase! The recipient will be notified and can start their journey with us.
        </p>
        <div className="bg-white rounded-lg p-4 mb-6 shadow-sm border border-sky-100">
          <p className="text-sm text-gray-500 mb-2">What happens next:</p>
          <ul className="text-sm text-gray-600 text-left space-y-1">
            <li>• The recipient will receive a notification</li>
            <li>• They can claim their gift package</li>
            <li>• You'll receive a confirmation email</li>
          </ul>
        </div>
        <a
          href="/"
          className="inline-block bg-gradient-to-r from-sky-600 to-blue-600 text-white px-6 py-3 rounded-lg hover:from-sky-700 hover:to-blue-700 transition-colors"
        >
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default GiftSuccess; 